import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useHistory } from "react-router-dom";
import BookingAgent from "./AI-Demos/BookingAgent";
import { RiRobot2Line } from "react-icons/ri";
import { LuCalendarClock, LuCalendarDays } from "react-icons/lu";
import { GrServices } from "react-icons/gr";
import { TbClock24, TbClockCheck } from "react-icons/tb";
import { MdApproval } from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import { ErrorAlert } from "../components/Elements/SweetAlerts";

const BookingAgentPage = () => {
  const history = useHistory();
  const [prompts, setPrompts] = useState([]);

  const handleGoHome = () => {
    history.push("/"); // Redirects to the homepage
  };

  // List of 15 prompts
  const listPrompts = [
    "I need to book an appointment for today at 2 PM.",
    "Can I schedule a meeting for tomorrow morning?",
    "I need to book a doctor’s appointment for Thursday morning.",
    "Set up an appointment for next weekend, Sunday at 5 PM.",
    "Find the earliest available slot this week for an appointment.",
    "Book an appointment for next Wednesday at 4 PM.",
    "Schedule a call for this Saturday at 10 AM.",
    "Reserve a time slot for tomorrow at 11 AM.",
    "I’d like to schedule something for next Monday at noon.",
    "Set up a meeting whenever you’re free after lunch tomorrow.",
    "Do you have any openings today after 4 PM?",
    "What’s the earliest available time tomorrow?",
    "Can I reschedule my appointment to next Friday at 2 PM?",
    "Check availability for this Thursday afternoon.",
    "Help me schedule an appointment ASAP!",
  ];

  // Function to get 5 random prompts
  const getRandomPrompts = () => {
    return listPrompts.sort(() => Math.random() - Math.random()).slice(0, 5);
  };

  useEffect(() => {
    scroll.scrollToTop();
    setPrompts(getRandomPrompts());

    try {
      let token = sessionStorage.getItem("token");
      if (token !== "") {
        let response = axios.get(
          `https://demo.conversantech.com/helper/calendar-booking-demo/store-token?token=${token}`
        );
      }
    } catch (error) {
      console.log("🚀 ~ BookingAgentPage.jsx:52 ~ useEffect ~ error:", error);
      ErrorAlert();
    }
  }, []);

  return (
    <>
      <Wrapper className="flexNullCenter flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <IconWrapper>
                <Icon>
                  <RiRobot2Line fontSize={44} />
                  {/* <IconImage
                    src="/lovable-uploads/34dc8e74-1772-4251-a987-c4d97eb6ccd1.png"
                    alt="Document icon"
                  /> */}
                  {/* <Decoration />
                  <Decoration />
                  <Decoration /> */}
                </Icon>
              </IconWrapper>
              <Title>Appointment Booking Agent</Title>
              <Subtitle>
                Your Personal Scheduling Assistant, Available 24/7
              </Subtitle>
              <Description>
                Say goodbye to phone tag and endless email chains. Our
                AI-powered booking agent handles all your appointment needs
                quickly and efficiently.
              </Description>
              <DescriptionPoint>
                {prompts.map((item, index) => {
                  return (
                    <PromptDiv
                      className="shadow"
                      duration="500ms"
                      delay={`${index * 200}ms`}
                      key={index}
                    >
                      <Prompt className="whiteColor">{item}</Prompt>
                    </PromptDiv>
                  );
                })}
              </DescriptionPoint>
            </TextContent>

            {/* Booking Agent */}
            <BookingAgent />
          </ContentWrapper>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Our AI-powered Appointment Booking Agent isn't just a tool—it's an
              intelligent assistant that transforms how users schedule services,
              <br />
              Making the process smarter, faster, and always available.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarDays fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Easy Appointment Scheduling
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Schedule appointments effortlessly with a simple and intuitive
                interface. Just tell us when and where, and we’ll handle the
                rest!
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuCalendarClock fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Flexible Time Options
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Choose from available slots or let us find the best time for
                you. We adapt to your schedule!
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <GrServices fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Service-Specific Booking
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Book appointments tailored to your needs—doctor visits, salon
                services, meetings, or consultations.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <TbClockCheck fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Real-Time Availability
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Check real-time availability and secure your spot instantly.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdApproval fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Fast Confirmation
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Receive instant confirmation for your bookings—no waiting
                required!
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <TbClock24 fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Available 24/7
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Our AI agent is always available to assist you—day or night!
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  padding: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
`;

const Subtitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const DescriptionPoint = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 1.6;
`;

const IconWrapper = styled.div`
  position: relative;
  margin-bottom: 32px;
  display: flex;
  @media (max-width: 600px) {
    justify-content: center;
  }
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const Icon = styled.div`
  width: 70px;
  height: 70px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const IconImage = styled.img`
  width: 40px;
  height: 40px;
`;

const Decoration = styled.div`
  position: absolute;
  width: 6px;
  height: 6px;
  background-color: #fbbf24;
  border-radius: 50%;

  &:nth-child(1) {
    top: -10px;
    right: 5px;
  }

  &:nth-child(2) {
    bottom: 5px;
    left: -8px;
  }

  &:nth-child(3) {
    bottom: 15px;
    right: -5px;
  }
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 600px) {
    justify-content: center;
  }
  @media (max-width: 1024px) {
    justify-content: space-around;
  }
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

// Fade-in animation
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const PromptDiv = styled.div`
  // padding: 5px 12px;
  // border-radius: 10px;
  // width: fit-content;
  // max-width: 600px;
  // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
  //   0 2px 4px -1px rgba(0, 0, 0, 0.06);
  // margin-bottom: 10px;

  background: #7620ff;
  padding: 10px 15px;
  border-radius: 12px;
  width: fit-content;
  max-width: 600px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 4px 4px -1px rgba(0, 0, 0, 0.06);
  margin-bottom: 15px;

  // Add animation
  animation: ${fadeIn} ease-in-out forwards;

  // Delay based on index (if dynamic)
  animation-duration: ${(props) => props.duration || "500ms"};
  animation-delay: ${(props) => props.delay || "0ms"};
`;

const Prompt = styled.p`
  font-size: 16px;
  font-weight: bold;
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

export default BookingAgentPage;
